import { useFormaliteService } from '@europrocurement/l2d-domain';
import { DossierOpenSearchJsonldOpensearchDossierRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierNumero = DossierOpenSearchJsonldOpensearchDossierRead & Record<string, unknown>;

const useDossierNumero = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchDossierNumero = (term: string): Promise<Array<DossierNumero>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term };

            searchTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchNumerosGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierNumero>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierNumero };
};

export default useDossierNumero;
